import { Tags } from '../Tags';
import { StatusBadge } from '../StatusBadge/StatusBadge';
import { ResourceThumbnail } from '@components/attachments';
import Icon from '@components/Icon/Icon';
import './ResourceCard.scss';

export const ResourceCard = ({ resource, displayType = 'grid', onClick, actions, hideEmpty = true }) => {

    const handleClick = () => {
        if (onClick) {
            onClick(resource);
        }
    };

    // Get the current quantity to display
    const getCurrentQuantity = () => {
        if (!resource.consumable) return null;

        // Use quantity data from dedicated endpoint if available, otherwise fall back to resource data
        const quantity = resource.current_quantity ?? resource.quantity ?? 0;
        const unit = resource.resource_metadata?.find(meta => meta.metadata_key === 'unit')?.value;

        return unit ? `${quantity} ${unit}` : quantity;
    };

    return (
        <div
            className={`resource-card resource-card--${displayType} ${onClick ? 'clickable' : ''}`}
            onClick={handleClick}
        >
            <div className="resource-header">
                <ResourceThumbnail
                    resourceId={resource.id}
                    resourceName={resource.name}
                    size={displayType === 'grid' ? 'large' : 'medium'}
                    hideEmpty={hideEmpty}
                    thumbnailSize={300}
                />

            </div>

            <div className="resource-content">
                <div className="resource-title-section">
                    <h3 className="resource-name">{resource.name}</h3>

                    {resource.description && (
                        <p className="resource-description">{resource.description}</p>
                    )}
                </div>
                <div className="resource-meta">
                    {resource.category && resource.category.name && (
                        <span
                            className="category-badge"
                            style={resource.category.color ? { backgroundColor: resource.category.color } : {}}
                        >
                            {resource.category.name}
                        </span>
                    )}

                    {resource.location && resource.location.name && (
                        <span className="location-badge">
                            <Icon icon="map-marker-alt" className="location-icon" />
                            <span className="location-name">{resource.location.name}</span>
                        </span>
                    )}
                </div>

                <div className="resource-status">
                    <StatusBadge
                        model={resource}
                        type="borrowing"
                        className="resource-status-badge"
                    />

                    {resource.consumable && (
                        <span className="resource-quantity">
                            {getCurrentQuantity()}
                        </span>
                    )}
                </div>

                {/* Tags */}
                {resource.tags && resource.tags.length > 0 && (
                    <div className="resource-tags">
                        <Tags
                            tags={resource.tags}
                            activeTags={new Set()}
                            interactive={false}
                            mode="display"
                            size="small"
                            variant="default"
                            maxDisplayed={3}
                        />
                    </div>
                )}
            </div>

            {false && actions && (
                <div className="resource-actions">
                    {actions}
                </div>
            )}
        </div>
    );
};

export default ResourceCard;
